// extracted by mini-css-extract-plugin
export default {"container":"widget_text_container__YSz5X","title":"widget_text_title__MyyOL","value":"widget_text_value__ccYqQ"};